/**
 * collar-personalization-v3.js  v3b
 * Paws Paws Miami — Premium collar page module
 *
 * Acceptance requirements:
 * 1. Color swatch → native carousel image swap + Shopify variant state update
 * 2. Color + size → exact variant ID mapping, zero mismatch
 * 3. Name/tile field editable on desktop, iPhone Safari, Android Chrome
 * 4. Placeholder hides when tiles present, returns on clear
 * 5. Cart: correct SKU + pup name + charms + tag engraving + add-ons
 */

(function () {
  'use strict';

  const cfg = window.ppmV3Config;
  if (!cfg) return;

  const MAX = 8;

  /* ─── State ─── */
  let selectedColor = null;
  let selectedSize  = null;
  let jewels        = []; // { type: 'letter'|'charm', value, imgSrc }

  /* ─── DOM ─── */
  const wrap = document.getElementById('ppm-v3');
  if (!wrap) return;
  if (wrap.dataset.giftFlowBound === 'true') return;
  wrap.dataset.giftFlowBound = 'true';

  const colorLabel    = document.getElementById('ppm3-color-label');
  const sizeLabel     = document.getElementById('ppm3-size-label');
  const colorError    = document.getElementById('ppm3-color-error');
  const sizeError     = document.getElementById('ppm3-size-error');
  const nameError     = document.getElementById('ppm3-name-error');
  const jewelsCounter = document.getElementById('ppm3-jewel-count');
  const tileField     = document.getElementById('ppm3-tile-field');
  const tilePh        = document.getElementById('ppm3-tile-ph');
  const tileTiles     = document.getElementById('ppm3-tile-tiles');
  const nameInput     = document.getElementById('ppm3-name-input');
  const clearBtn      = document.getElementById('ppm3-clear');
  const cbBedazzled   = document.getElementById('ppm3-cb-bedazzled');
  const cbTag         = document.getElementById('ppm3-cb-tag');
  const tagFields     = document.getElementById('ppm3-tag-fields');
  const frontInput    = document.getElementById('ppm3-front');
  const backInput     = document.getElementById('ppm3-back');
  const frontError    = document.getElementById('ppm3-front-error');
  const shippingText  = document.getElementById('ppm3-shipping-text');
  const atcBtn        = document.getElementById('ppm3-atc');
  const atcError      = document.getElementById('ppm3-atc-error');
  const swatchBtns    = wrap.querySelectorAll('.ppm3-swatch');
  const sizeBtns      = wrap.querySelectorAll('.ppm3-size-btn');
  const charmTiles    = wrap.querySelectorAll('.ppm3-charm-tile');

  /* ─── Native carousel helpers ─── */
  function swapNativeCarousel(imgUrl) {
    // Ride 15.4: first slide img in the product media gallery
    const selectors = [
      '.product__media-item:first-child img',
      '.product-media-container img',
      '.product__media img',
      '.product-single__media img',
      '[data-media-type="image"]:first-of-type img',
      '.swiper-slide:first-child img',
      '.product__photo img'
    ];
    for (const sel of selectors) {
      const img = document.querySelector(sel);
      if (img) {
        // Store original src if not already stored
        if (!img.dataset.origSrc) img.dataset.origSrc = img.src;
        img.src = imgUrl;
        if (img.srcset) { img.dataset.origSrcset = img.srcset; img.srcset = ''; }
        return true;
      }
    }
    return false;
  }

  function updateShopifyVariantState(variantId) {
    // Update Shopify's hidden variant input so native checkout gets correct variant
    const variantInput = document.querySelector('input[name="id"]');
    if (variantInput) {
      variantInput.value = variantId;
      variantInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    // Also update the URL for Shopify's analytics
    if (history.replaceState) {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variantId);
      history.replaceState({}, '', url.toString());
    }
  }

  /* ─── Availability map — fetched from Shopify product JSON ─── */
  const availability = {};

  fetch(window.location.pathname.split('?')[0] + '.js')
    .then(r => r.json())
    .then(product => {
      product.variants.forEach(v => {
        const color = v.option1;
        const size  = v.option2 ? v.option2.split(' ')[0] : null;
        if (color && size) {
          if (!availability[color]) availability[color] = {};
          availability[color][size] = v.available;
        }
      });
    })
    .catch(() => {}); // silently fail — all sizes show if fetch fails

  /* ─── Show/hide size buttons based on selected color availability ─── */
  function updateSizeAvailability(color) {
    const colorAvail = availability[color] || {};
    sizeBtns.forEach(btn => {
      const size = btn.dataset.size;
      const avail = colorAvail[size];
      // If we have data and it's explicitly false, hide
      if (Object.keys(colorAvail).length > 0 && avail === false) {
        btn.style.display = 'none';
      } else {
        btn.style.display = '';
      }
    });
  }

  function updateColorAvailability(size) {
  swatchBtns.forEach(btn => {
    const color = btn.dataset.color;
    const colorAvail = availability[color] || {};
    if (Object.keys(colorAvail).length > 0 && colorAvail[size] === false) {
      btn.style.display = 'none';
    } else {
      btn.style.display = '';
    }
  });
}

  /* ─── Color selection ─── */
  swatchBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      swatchBtns.forEach(b => b.classList.remove('ppm3-swatch--selected'));
      btn.classList.add('ppm3-swatch--selected');
      selectedColor = btn.dataset.color;
      colorLabel.textContent = selectedColor;
      colorError.hidden = true;

      // Reset size selection
      selectedSize = null;
      sizeLabel.textContent = '— select below';
      sizeBtns.forEach(b => b.classList.remove('ppm3-size-btn--selected'));

      // Show/hide sizes by availability for this color
      updateSizeAvailability(selectedColor);

      // Swap native carousel
      const imgUrl = btn.dataset.collarImg;
      if (imgUrl) swapNativeCarousel(imgUrl);

      updateShipping();
    });
  });

  /* ─── Size selection ─── */
  sizeBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      sizeBtns.forEach(b => b.classList.remove('ppm3-size-btn--selected'));
      btn.classList.add('ppm3-size-btn--selected');
      selectedSize = btn.dataset.size;
      sizeLabel.textContent = selectedSize;
      sizeError.hidden = true;

updateColorAvailability(selectedSize);

      // Update Shopify variant state
      if (selectedColor) {
        const vid = getVariantId();
        if (vid) updateShopifyVariantState(vid);
      }

      updateShipping();
    });
  });

  /* ─── Tile field interaction ─── */

  // Clicking anywhere on the tile field focuses the hidden input
  tileField.addEventListener('click', () => {
    nameInput.focus();
  });

  tileField.addEventListener('touchend', (e) => {
    e.preventDefault();
    nameInput.focus();
  }, { passive: false });

  /* ─── Name input — letter tiles ─── */
  nameInput.addEventListener('keydown', e => {
    if (e.key === 'Backspace') {
      e.preventDefault();
      removeLast();
      return;
    }
  });

  nameInput.addEventListener('input', () => {
    // Take whatever was typed, process it, clear the input
    const val = nameInput.value;
    nameInput.value = '';
    if (!val) return;

    for (const ch of val.toUpperCase()) {
      if (jewels.length >= MAX) break;
      if (/^[A-Z ]$/.test(ch)) {
        const imgSrc = cfg.letterAssets[ch] || null;
        jewels.push({ type: 'letter', value: ch, imgSrc });
      }
    }

    renderTiles();
    nameError.hidden = true;
    updateShipping();
  });

  // Handle paste on mobile
  nameInput.addEventListener('paste', e => {
    e.preventDefault();
    const text = (e.clipboardData || window.clipboardData).getData('text');
    for (const ch of text.toUpperCase()) {
      if (jewels.length >= MAX) break;
      if (/^[A-Z ]$/.test(ch)) {
        jewels.push({ type: 'letter', value: ch, imgSrc: cfg.letterAssets[ch] || null });
      }
    }
    renderTiles();
    updateShipping();
  });

  function removeLast() {
    if (jewels.length > 0) {
      jewels.pop();
      renderTiles();
      updateShipping();
    }
  }

  /* ─── Charm tiles ─── */
  charmTiles.forEach(tile => {
    tile.addEventListener('click', () => {
      if (jewels.length >= MAX) return;
      jewels.push({
        type: 'charm',
        value: tile.dataset.token,
        imgSrc: tile.dataset.img
      });
      renderTiles();
      nameError.hidden = true;
      updateShipping();
      nameInput.focus();
    });
  });

  /* ─── Clear ─── */
  clearBtn.addEventListener('click', () => {
    jewels = [];
    nameInput.value = '';
    renderTiles();
    updateShipping();
  });

  /* ─── Render tiles ─── */
  function renderTiles() {
    tileTiles.innerHTML = '';

    jewels.forEach(j => {
      const tile = document.createElement('div');
      tile.className = 'ppm3-jewel-tile';

      if (j.imgSrc) {
        const img = document.createElement('img');
        img.src = j.imgSrc;
        img.alt = j.value;
        tile.appendChild(img);
      } else {
        // Fallback text for space or unknown
        tile.style.cssText = 'font-size:.9rem;color:#999;';
        tile.textContent = j.value === ' ' ? '·' : j.value;
      }

      tileTiles.appendChild(tile);
    });

    // Placeholder visibility
    if (jewels.length > 0) {
      tilePh.classList.add('ppm3-tile-field__ph--hidden');
    } else {
      tilePh.classList.remove('ppm3-tile-field__ph--hidden');
    }

    // Counter
    jewelsCounter.textContent = jewels.length;
  }

  /* ─── Upsell toggles ─── */
  cbBedazzled.addEventListener('change', () => {
    cbBedazzled.closest('.ppm3-upsell').classList.toggle('ppm3-upsell--checked', cbBedazzled.checked);
    updateShipping();
  });

  cbTag.addEventListener('change', () => {
    const on = cbTag.checked;
    cbTag.closest('.ppm3-upsell').classList.toggle('ppm3-upsell--checked', on);
    tagFields.hidden = !on;
    if (!on) {
      frontInput.classList.remove('ppm3-field__input--error');
      frontError.hidden = true;
    }
    updateShipping();
  });

  frontInput.addEventListener('input', () => {
    if (frontInput.value.trim()) {
      frontInput.classList.remove('ppm3-field__input--error');
      frontError.hidden = true;
    }
  });

  /* ─── Shipping note ─── */
  function getTotal() {
    let t = cfg.collarBasePrice;
    if (cbBedazzled.checked) t += 1500;
    if (cbTag.checked)       t += 2800;
    return t;
  }

  function updateShipping() {
    if (!shippingText) return;
    const total = getTotal();
    if (total >= cfg.freeShippingThreshold) {
      shippingText.textContent = 'Free shipping $75+ | Ships 3–5 days';
    } else {
      shippingText.textContent = 'Free shipping $75+ | Ships 3–5 days';
    }
  }

  /* ─── Variant lookup ─── */
  function getVariantId() {
    if (!selectedColor || !selectedSize) return null;
    const colorMap = cfg.variants[selectedColor];
    if (!colorMap) return null;
    return colorMap[selectedSize] || null;
  }

  /* ─── Validation ─── */
  function validate() {
    let valid = true;

    if (!selectedColor) {
      colorError.hidden = false;
      wrap.querySelector('.ppm3-swatch').scrollIntoView({ behavior: 'smooth', block: 'center' });
      valid = false;
    }

    if (!selectedSize) {
      sizeError.hidden = false;
      if (valid) wrap.querySelector('.ppm3-size-btn').scrollIntoView({ behavior: 'smooth', block: 'center' });
      valid = false;
    }

    if (jewels.length === 0) {
      nameError.hidden = false;
      if (valid) tileField.scrollIntoView({ behavior: 'smooth', block: 'center' });
      valid = false;
    }

    if (cbTag.checked && !frontInput.value.trim()) {
      frontInput.classList.add('ppm3-field__input--error');
      frontError.hidden = false;
      if (valid) frontInput.scrollIntoView({ behavior: 'smooth', block: 'center' });
      valid = false;
    }

    return valid;
  }

  /* ─── Cart properties ─── */
  function buildCollarProps() {
    return {
      'Customized':      jewels.map(j => j.value).join(' '),
      '_Jewels tokens':  jewels.map(j => j.value).join(''),
      '_Letters count':  jewels.filter(j => j.type === 'letter').length,
      '_Charms count':   jewels.filter(j => j.type === 'charm').length,
      '_Letters string': jewels.filter(j => j.type === 'letter').map(j => j.value).join(''),
      '_Jewels count':   `${jewels.length}/8`
    };
  }

  /* Gift packaging shares the existing collar submission; never a second ATC handler. */
  const giftBox = document.getElementById('ppm3-gift');
  const giftToggle = document.getElementById('ppm3-cb-gift');
  const giftFields = document.getElementById('ppm3-gift-fields');
  const giftMessage = document.getElementById('ppm3-gift-message');
  const giftStatus = document.getElementById('ppm3-gift-status');
  const giftVariantId = 67699250004243;
  const root = window.Shopify?.routes?.root || '/';
  let submitting = false;
  let uncertain = false;
  let giftExists = false;
  const giftInCart = cart => cart.items.some(item => String(item.variant_id || item.id) === String(giftVariantId) || String(item.product_id) === '15412344881427');
  function showExistingGift() {
    giftExists = true;
    giftToggle.checked = true;
    giftMessage.disabled = true;
    giftFields.hidden = true;
    giftStatus.textContent = 'Gift box already in your cart.';
  }
  async function readCart() {
    const response = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' });
    if (!response.ok) throw new Error('Cart check failed');
    const cart = await response.json();
    if (!Array.isArray(cart.items)) throw new Error('Invalid cart response');
    return cart;
  }
  function withoutGift(message) {
    giftToggle.checked = false;
    giftToggle.disabled = true;
    giftFields.hidden = true;
    giftStatus.textContent = message + ' You can still add your collar without gifting.';
  }
  if (giftToggle) {
    giftToggle.checked = false;
    giftFields.hidden = true;
    giftToggle.addEventListener('change', () => {
      giftFields.hidden = !giftToggle.checked || giftExists;
      if (giftToggle.checked) {
        readCart().then(cart => {
          if (!giftToggle.checked) return;
          if (giftInCart(cart)) showExistingGift();
          else { giftExists = false; giftMessage.disabled = false; giftFields.hidden = false; giftStatus.textContent = ''; }
        })
          .catch(() => withoutGift('We could not confirm your gift-box cart status.'));
      }
    });
  }
  // Display only: Monster currently omits native line properties in its drawer.
  // This adapter runs only while the collar PDP module is loaded.
  const itemSignature = item => JSON.stringify([String(item.variant_id || item.id), Object.entries(item.properties || {}).filter(([,v]) => v !== '').map(([k,v]) => [k,String(v)]).sort(([a],[b]) => a.localeCompare(b))]);
  function itemQuantity(cart, item) {
    const signature = itemSignature(item);
    return cart.items.filter(line => itemSignature(line) === signature).reduce((sum,line) => sum + line.quantity, 0);
  }

  /* ─── Add to cart ─── */
  async function addToCart() {
    if (submitting || uncertain) return;
    atcError.hidden = true;
    if (!validate()) return;

    const variantId = getVariantId();
    if (!variantId) {
      showError('Could not find your collar variant. Please refresh and try again.');
      return;
    }

    const items = [{ id: variantId, quantity: 1, properties: buildCollarProps() }];

    if (cbBedazzled.checked) {
      items.push({ id: cfg.bedazzledVariantId, quantity: 1, properties: {} });
    }

    if (cbTag.checked) {
      const props = { 'Front Engraving': frontInput.value.trim() };
      const back  = backInput ? backInput.value.trim() : '';
      if (back) props['Back Engraving'] = back;
      items.push({ id: cfg.idTagVariantId, quantity: 1, properties: props });
    }


    submitting = true;
    setLoading(true);
    let before = null;
    let postStarted = false;
    try {
      before = await readCart();
      if (giftToggle?.checked) {
        if (giftInCart(before)) {
          showExistingGift();
        } else {
          giftExists = false;
          giftMessage.disabled = false;
          const response = await fetch(giftBox.dataset.url + '.js', { headers: { Accept: 'application/json' }, cache: 'no-store' });
          if (!response.ok) throw new Error('Gift availability check failed');
          const product = await response.json();
          const variant = product.variants?.find(v => String(v.id) === String(giftVariantId));
          if (!variant?.available || variant.price !== 1000) {
            withoutGift('Gift box is currently unavailable.');
            return;
          }
          const message = giftMessage.value.trim();
          if (message.length > 200) {
            showError('Please keep your gift message to 200 characters.');
            return;
          }
          items.push({ id: giftVariantId, quantity: 1, properties: message ? { 'Gift Message': message } : {} });
        }
      }
      postStarted = true;
      const res = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items })
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || data.message || 'Could not add to cart.');
      await readCart();
      openCart();
    } catch (err) {
      if (!postStarted) {
        if (giftToggle?.checked) withoutGift('We could not confirm gift-box availability or your cart.');
        showError('Could not verify your cart. Please try again; nothing was submitted.');
      } else {
        // A rejected or lost response can still accompany a cart change. Never replay it.
        try {
          const after = await readCart();
          if (items.every(item => itemQuantity(after,item) >= itemQuantity(before,item) + item.quantity)) {

            openCart();
          } else {
            uncertain = true;
            showError('We could not confirm the complete addition. Please review your cart before adding again.');
            const link = document.createElement('a');
            link.href = window.routes?.cart_url || root + 'cart';
            link.textContent = ' Review cart';
            atcError.append(link);
          }
        } catch (_) {
          uncertain = true;
          showError('Connection interrupted. Please open your cart to check what was added before trying again.');
          const link = document.createElement('a');
          link.href = window.routes?.cart_url || root + 'cart';
          link.textContent = ' Review cart';
          atcError.append(link);
        }
      }
    } finally {
      submitting = false;
      setLoading(false);
      if (uncertain) atcBtn.disabled = true;
    }
  }
function openCart() {
  if (typeof window.monster_refresh === 'function' && document.getElementById('monster-cart-wrapper')) {
    window.monster_refresh();
  } else {
    window.location.assign(window.routes && window.routes.cart_url || '/cart');
  }
}

  function setLoading(on) {
    const txt  = atcBtn.querySelector('.ppm3-atc__text');
    const spin = atcBtn.querySelector('.ppm3-atc__spin');
    atcBtn.classList.toggle('ppm3-atc--loading', on);
    atcBtn.disabled = on;
    if (txt)  txt.hidden  = on;
    if (spin) spin.hidden = !on;
  }

  function showError(msg) {
    atcError.textContent = msg;
    atcError.hidden = false;
  }

  /* ─── Init ─── */
  atcBtn.addEventListener('click', addToCart);
  updateShipping();
  renderTiles();

    // Size guide popup
  const sgTrigger = document.querySelector('.ppm3-size-guide-link');
  if (sgTrigger) {
    const backdrop = document.createElement('div');
    backdrop.style.cssText = 'display:none;position:fixed;top:0;left:0;width:100vw;height:100vh;background:rgba(0,0,0,0.55);z-index:99997;';
    document.body.appendChild(backdrop);

    const box = document.createElement('div');
    box.style.cssText = 'display:none;position:fixed;top:50%;left:50%;transform:translate(-50%,-50%);width:90vw;max-width:480px;background:#fff;padding:36px 28px 48px;box-sizing:border-box;box-shadow:0 8px 40px rgba(0,0,0,0.18);z-index:99999;';
    box.innerHTML = `
      <button id="ppm3-sg-close" style="position:absolute;top:0;right:0;width:44px;height:44px;background:none;border:none;font-size:20px;cursor:pointer;color:#3a3a3a;display:flex;align-items:center;justify-content:center;">✕</button>
      <p style="font-family:'Playfair Display',Georgia,serif;font-size:18px;font-weight:700;color:#3a3a3a;margin:0 0 20px;">Collar Size Guide</p>
      <table style="width:100%;border-collapse:collapse;font-size:14px;color:#3a3a3a;table-layout:fixed;">
        <colgroup><col style="width:15%;"><col style="width:50%;"><col style="width:35%;"></colgroup>
        <thead><tr>
          <th style="text-align:left;padding:10px 8px;border-bottom:1px solid rgba(0,0,0,0.18);color:#3a3a3a;font-weight:600;">Size</th>
          <th style="text-align:left;padding:10px 8px;border-bottom:1px solid rgba(0,0,0,0.18);color:#3a3a3a;font-weight:600;">Neck Measurement</th>
          <th style="text-align:left;padding:10px 8px;border-bottom:1px solid rgba(0,0,0,0.18);color:#3a3a3a;font-weight:600;">Collar Width</th>
        </tr></thead>
        <tbody>
          <tr><td style="padding:10px 8px;border-bottom:1px solid rgba(0,0,0,0.06);color:#3a3a3a;">XS</td><td style="padding:10px 8px;border-bottom:1px solid rgba(0,0,0,0.06);color:#3a3a3a;">6 to 10"</td><td style="padding:10px 8px;border-bottom:1px solid rgba(0,0,0,0.06);color:#3a3a3a;">5/8"</td></tr>
          <tr><td style="padding:10px 8px;border-bottom:1px solid rgba(0,0,0,0.06);color:#3a3a3a;">S</td><td style="padding:10px 8px;border-bottom:1px solid rgba(0,0,0,0.06);color:#3a3a3a;">9 to 12"</td><td style="padding:10px 8px;border-bottom:1px solid rgba(0,0,0,0.06);color:#3a3a3a;">5/8"</td></tr>
          <tr><td style="padding:10px 8px;border-bottom:1px solid rgba(0,0,0,0.06);color:#3a3a3a;">M</td><td style="padding:10px 8px;border-bottom:1px solid rgba(0,0,0,0.06);color:#3a3a3a;">11 to 15"</td><td style="padding:10px 8px;border-bottom:1px solid rgba(0,0,0,0.06);color:#3a3a3a;">3/4"</td></tr>
          <tr><td style="padding:10px 8px;border-bottom:1px solid rgba(0,0,0,0.06);color:#3a3a3a;">L</td><td style="padding:10px 8px;border-bottom:1px solid rgba(0,0,0,0.06);color:#3a3a3a;">15 to 19"</td><td style="padding:10px 8px;border-bottom:1px solid rgba(0,0,0,0.06);color:#3a3a3a;">1"</td></tr>
          <tr><td style="padding:10px 8px;color:#3a3a3a;">XL</td><td style="padding:10px 8px;color:#3a3a3a;">17 to 21"</td><td style="padding:10px 8px;color:#3a3a3a;">1"</td></tr>
        </tbody>
      </table>`;
    document.body.appendChild(box);

    function openSG() {
      backdrop.style.display = 'block';
      box.style.display = 'block';
      document.body.style.overflow = 'hidden';
    }

    function closeSG() {
      backdrop.style.display = 'none';
      box.style.display = 'none';
      document.body.style.overflow = '';
    }

    sgTrigger.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      openSG();
    });
    backdrop.addEventListener('click', closeSG);
    box.querySelector('#ppm3-sg-close').addEventListener('click', closeSG);
  }

})();